export const analyticsConfig = {
  get measurementId(): string {
    return import.meta.env.VITE_GA_MEASUREMENT_ID ?? ''
  },
  get isEnabled(): boolean {
    return Boolean(this.measurementId)
  },
} as const
